import * as _ from 'underscore';
import { ExtractTaskDefinition } from '../models/ContentDefinitions';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { ExtractTaskTargetType, IExtractTask } from '../ServerApi/types/IExtractTask';
import { ISchedule } from '../ServerApi/types/ISchedule';
import { ISiteNameWithId } from '../ServerApi/types/ISiteNameWithId';
import { INamedItem } from '../ServerApi/types/resourceParts';
import { MapperHelper } from './MapperHelper';

export module ExtractTaskMapper {

  const M = MapperHelper;

  export function map(
    dcs: IExtractTask[],
    schedule: _.Dictionary<ISchedule>,
    site: _.Dictionary<ISiteNameWithId>,
    workbooks: _.Dictionary<INamedItem>,
    datasources: _.Dictionary<INamedItem>): IExtractTaskInfo[] {

    return _.map(dcs, (et: IExtractTask) => {

      const targetWorkbook = et.targetType === ExtractTaskTargetType.Workbook ? workbooks[et.targetId] : undefined;
      const targetDatasource = et.targetType === ExtractTaskTargetType.Datasource ? datasources[et.targetId] : undefined;

      return {
        id:          et.id,
        contentType: ExtractTaskDefinition.itemType,
        priority:    et.priority,
        type:        et.type,
        lastRunAt:   M.toDate(et.lastRunAt),
        runNextAt:   M.toDate(et.runNextAt),
        schedule:    schedule[et.scheduleId],
        site:        site[et.siteId],
        workbook:    targetWorkbook,
        datasource:  targetDatasource,
        state:       et.state,
      };
    });
  }

}
